(() => {
  function normalizeSize(value) {
    const key = String(value || '').toLowerCase().split('(')[0].replace(/[^a-z]/g, '');
    const aliases = { twinextralong:'twinxl', calking:'californiaking', california:'californiaking' };
    return aliases[key] || key;
  }
  function matchProducts(products, size, budget = 'all') {
    const [min, max] = budget.split(':').map(value => value === '' ? Infinity : Number(value) * 100);
    return products.flatMap(product => {
      if (budget !== 'all' && product.system) return [];
      const candidates = product.variants.filter(variant => normalizeSize(variant.size) === normalizeSize(size) &&
        (budget === 'all' || (variant.price > 0 && variant.price >= min && variant.price < max)));
      // Prefer a purchasable, priced variant; never invent a pair price or use another size.
      candidates.sort((a,b) => Number(b.price > 0) - Number(a.price > 0) || Number(b.available) - Number(a.available) || a.price-b.price);
      return candidates.length ? [{product, variant:candidates[0]}] : [];
    });
  }
  window.TscMattressCatalog = {normalizeSize, matchProducts};
  if (customElements.get('tsc-mattress-shop')) return;
  class TscMattressShop extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.status = this.querySelector('[data-shop-status]');
      this.size = this.querySelector('[data-shop-size]');
      this.budget = this.querySelector('[data-shop-budget]');
      this.sort = this.querySelector('[data-shop-sort]');
      this.grid = this.querySelector('[data-shop-results]');
      const params = new URL(window.location.href).searchParams;
      const requestedSize = [...this.size.options].find(option => normalizeSize(option.value) === normalizeSize(params.get('size')));
      if (requestedSize) this.size.value = requestedSize.value;
      const requestedBudget = `${params.get('min') || '0'}:${params.get('max') || ''}`;
      if ((params.has('min') || params.has('max')) && [...this.budget.options].some(option => option.value === requestedBudget)) this.budget.value = requestedBudget;
      if (['low','high'].includes(params.get('order'))) this.sort.value = params.get('order');
      try {
        this.products = JSON.parse(this.querySelector('[data-shop-catalog]').textContent);
        // Read every collection page before displaying complete results, including catalogs over 250 products.
        let next = this.dataset.next;
        const visited = new Set();
        while (next) {
          const url = new URL(next, window.location.href);
          url.searchParams.set('view','tsc-shop');
          if (url.origin !== window.location.origin || visited.has(url.href)) throw Error('Invalid catalog pagination');
          visited.add(url.href);
          const response = await fetch(url.href, {credentials:'same-origin'});
          if (!response.ok) throw Error('Catalog page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = doc.querySelector('tsc-mattress-shop');
          if (!root) throw Error('Catalog page unavailable');
          this.products.push(...JSON.parse(root.querySelector('[data-shop-catalog]').textContent));
          next = root.dataset.next;
        }
        this.products = [...new Map(this.products.map(product => [product.id, product])).values()];
        this.querySelector('.tsc-shop__filters').hidden = false;
        [this.size,this.budget,this.sort].forEach(control => control.addEventListener('change', () => this.render(true)));
        this.render(false);
      } catch (_) {
        this.status.textContent = 'We couldn’t load all mattress prices. Please refresh, or use “All mattresses” above.';
        this.grid.replaceChildren();
      }
    }
    render(updateUrl) {
      const size = this.size.value;
      const matches = matchProducts(this.products, size, this.budget.value);
      if (this.sort.value !== 'featured') matches.sort((a,b) => {
        if (!a.variant.price) return b.variant.price ? 1 : 0;
        if (!b.variant.price) return -1;
        return this.sort.value === 'low' ? a.variant.price-b.variant.price : b.variant.price-a.variant.price;
      });
      const budgetLabel = this.budget.selectedOptions[0].textContent;
      const headingBudget = this.budget.value === 'all' ? '' : ` ${budgetLabel.trim().replace(/\s*[–—-]\s*/g, ' - ')}`;
      this.querySelector('[data-shop-heading]').textContent = `${size} Mattresses${headingBudget}`;
      this.status.textContent = `${matches.length} ${matches.length === 1 ? 'match' : 'matches'} · ${size} · ${budgetLabel}`;
      this.querySelector('[data-shop-empty]').hidden = matches.length !== 0;
      const fragment = document.createDocumentFragment();
      matches.forEach(({product,variant}) => {
        const article = document.createElement('article'); article.className = 'tsc-shop__card';
        const link = document.createElement('a');
        const productUrl = new URL(product.url, window.location.href);
        productUrl.searchParams.set('variant', variant.id);
        link.href = productUrl.pathname + productUrl.search;
        if (product.image) {
          const img = document.createElement('img'); img.src=product.image; img.alt=product.title; img.width=600; img.height=450; img.loading='lazy'; link.append(img);
        }
        const copy = document.createElement('div'); copy.className='tsc-shop__copy';
        const add = (tag, className, text) => { const node=document.createElement(tag); node.className=className; node.textContent=text; copy.append(node); };
        add('span','tsc-shop__vendor',product.vendor);
        add('h2','',product.title);
        add('span','tsc-shop__size',size + (product.system ? ' · Complete bed system' : ' · Mattress only'));
        add('span','tsc-shop__price',variant.price > 0 ? variant.money : 'Contact store for price');
        if (!variant.available) add('span','tsc-shop__availability','Currently unavailable online');
        add('span','tsc-shop__cta','View this size →');
        link.append(copy); article.append(link); fragment.append(article);
      });
      this.grid.replaceChildren(fragment);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('size',size); url.searchParams.delete('min'); url.searchParams.delete('max'); url.searchParams.delete('page');
        if (this.budget.value !== 'all') {
          const [min,max] = this.budget.value.split(':'); url.searchParams.set('min',min); if (max) url.searchParams.set('max',max);
        }
        url.searchParams.set('order',this.sort.value);
        window.history.replaceState(null,'',url.href);
      }
    }
  }
  customElements.define('tsc-mattress-shop', TscMattressShop);
})();
